import React from 'react';
import { Award, Heart, Lightbulb } from 'lucide-react';

const Founder = () => {
  return (
    <div className="founder-page">
      {/* Hero Section */}
      <section className="py-20 bg-[#f5f3f8]">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            {/* Founder Image Column */}
            <div>
              <div className="relative rounded-3xl shadow-2xl overflow-hidden" style={{
                background: 'linear-gradient(135deg, #f0f9ff 0%, #f5f3f8 25%, #faf5ff 75%, #f5f3f8 100%)'
              }}>
                <div className="relative p-8">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_learntree-edu/artifacts/us2uwsty_b8f24479-b699-49ef-8149-8d2a693b6827.jpeg"
                    alt="Jagriti Mehta - Founder of Tinkred"
                    className="rounded-2xl w-full h-auto object-cover mx-auto"
                    style={{
                      minHeight: '700px',
                      maxHeight: '700px',
                      objectPosition: 'center 20%',
                      filter: 'brightness(1.05) contrast(1.02) saturate(1.05)',
                      boxShadow: '0 10px 40px rgba(20, 184, 166, 0.15)'
                    }}
                  />
                </div>
              </div>
              
              {/* Name Card - Separate from image */}
              <div style={{
                marginTop: '30px',
                backgroundColor: '#ffffff',
                borderRadius: '20px',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)',
                padding: '35px',
                border: '3px solid transparent',
                backgroundImage: 'linear-gradient(white, white), linear-gradient(90deg, #14b8a6 0%, #3b82f6 50%, #a855f7 100%)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box'
              }}>
                <h2 style={{
                  fontSize: '30px',
                  fontWeight: 'bold',
                  color: '#000000',
                  marginBottom: '10px'
                }}>
                  Jagriti Mehta
                </h2>
                <h3 style={{
                  fontSize: '22px',
                  fontWeight: '600',
                  background: 'linear-gradient(90deg, #14b8a6 0%, #3b82f6 50%, #a855f7 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  marginBottom: '20px',
                  display: 'inline-block'
                }}>
                  Founder, Tinkred
                </h3>
                <p style={{
                  fontSize: '17px',
                  color: '#374151',
                  fontStyle: 'italic',
                  lineHeight: '1.8'
                }}>
                  "At Tinkred, we believe every child's emotional wellbeing is the foundation of lifelong learning. My mission is to empower parents and educators to nurture this from the very beginning."
                </p>
              </div>
            </div>
            
            <div className="space-y-6" data-testid="founder-bio">
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-800">Founder's Note</h1>
              
              <div className="space-y-4 text-base text-gray-700 leading-relaxed">
                <p>
                  Jagriti Mehta is an education professional with extensive experience in early childhood education, curriculum development, and educator training. Over the past decade, she has worked across leading institutions, designing child-centered curriculums, mentoring teachers, and creating emotionally supportive learning environments that prioritize holistic development.
                </p>
                
                <p>
                  Her work is grounded in the belief that learning is most meaningful when it nurtures both the mind and the heart. Through her professional journey, she recognized the growing need for educational spaces that not only cultivate knowledge, but also emotional resilience, mental wellbeing, and empathetic communication—for learners, parents, and educators alike. This understanding led to the creation of Tinkred, a platform dedicated to human-centered and emotionally intelligent learning.
                </p>
                
                <p>
                  At Tinkred, the mission is to empower individuals—whether they are Gen Z learners managing stress, teachers strengthening their classroom practice, parents guiding their children, or professionals growing in their careers. The platform offers online courses, mental wellbeing guidance, early childhood education training, and ready-to-use curriculums and lesson plans, helping educators and families bring thoughtful, balanced, and creative learning into everyday life.
                </p>
                
                <p>
                  Jagriti envisions a learning community where knowledge is supported by emotional awareness, where teaching is guided by care and curiosity, and where every learner can grow with clarity, confidence, and purpose. Through Tinkred, she continues to work toward building stronger minds, kinder hearts, and more meaningful learning experiences for all.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Founder;